<template>
  <v-container fluid>
    <ActionBar
      :filters="filters"
      :reportItems="reportItems"
      :activeTab="activeTab"
      :selectedPeriod="selectedPeriod"
      @goToNewConsolidatedReport="goToNewConsolidatedReport"
      @goToConsolidatedReports="goToConsolidatedReportsPage"
    />

    <div class="page__content">
      <v-tabs
        v-model="activeTab"
        slider-color="secondary"
        class="v-tabs-reports"
        :class="{ 'v-tabs-reports__hidden': tabsCount <= 1 }"
      >
        <v-tab
          v-show="claims.report['ROLE_GET_REPORT_TAXIJOBS']"
          ripple
        >{{ $t(`${namespace}.byRides`) }}</v-tab>

        <v-tab
          v-show="claims.report['ROLE_GET_REPORT_COSTCENTER']"
          ripple
        >{{ $t(`${namespace}.byCostCenter`) }}</v-tab>

        <v-tab
          v-show="claims.report['ROLE_GET_REPORT_EMPLOYEE']"
          ripple
        >{{ $t(`${namespace}.byEmployee`) }}</v-tab>

        <v-tabs-items touchless>
          <v-tab-item>
            <ReportRides
              v-if="claims.report['ROLE_GET_REPORT_TAXIJOBS'] && activeTab === 0"
              :activeTab="activeTab"
              :clearSelectedItem="clearSelectedItem"
              @updateFilters="updateFilters"
              @openDrawer="openRideDrawer"
              @changePeriod="changePeriod"
              @setReportItems="setReportItems"
            />
          </v-tab-item>

          <v-tab-item>
            <ReportCostCenter
              v-if="claims.report['ROLE_GET_REPORT_COSTCENTER'] && activeTab === 1"
              :activeTab="activeTab"
              :clearSelectedItem="clearSelectedItem"
              @updateFilters="updateFilters"
              @openDrawer="openCostCenterDrawer"
              @changePeriod="changePeriod"
              @setReportItems="setReportItems"
            />
          </v-tab-item>

          <v-tab-item>
            <ReportEmployee
              v-if="claims.report['ROLE_GET_REPORT_EMPLOYEE'] && activeTab === 2"
              :activeTab="activeTab"
              :clearSelectedItem="clearSelectedItem"
              @updateFilters="updateFilters"
              @openDrawer="openEmployeeDrawer"
              @changePeriod="changePeriod"
              @setReportItems="setReportItems"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>

    <GlobalDrawer
      :show="globalDrawer.visibility"
      :drawerType="globalDrawer.type"
      :data="globalDrawer.data"
      :filters="globalDrawer.filters"
      @close="closeGlobalDrawer"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { isObject } from 'utils/functions'
import ActionBar from 'components/reports/ActionBar'
import ReportRides from 'components/reports/rides'
import ReportCostCenter from 'components/reports/costCenter'
import ReportEmployee from 'components/reports/employee'
import GlobalDrawer from 'components/globalDrawer'

export default {
  name: 'ReportsPage',
  components: {
    ActionBar,
    ReportRides,
    ReportCostCenter,
    ReportEmployee,
    GlobalDrawer
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    }),

    routeReportType () {
      return this.$route.params.type
    },

    tabsCount () {
      const ROLE_GET_REPORT_TAXIJOBS = this.claims.report['ROLE_GET_REPORT_TAXIJOBS']
      const ROLE_GET_REPORT_COSTCENTER = this.claims.report['ROLE_GET_REPORT_COSTCENTER']
      const ROLE_GET_REPORT_EMPLOYEE = this.claims.report['ROLE_GET_REPORT_EMPLOYEE']
      const tabsArray = [ROLE_GET_REPORT_TAXIJOBS, ROLE_GET_REPORT_COSTCENTER, ROLE_GET_REPORT_EMPLOYEE]
        .filter(tab => tab === true)
      return tabsArray.length
    }
  },
  data () {
    return {
      namespace: 'Views.ReportsPage',
      filters: {
        rides: null,
        costCenter: null,
        employee: null
      },
      activeTab: 0,
      clearSelectedItem: false,
      selectedPeriod: null,
      consolidatedReportDialogVisibility: false,
      reportItems: 0,
      globalDrawer: {
        visibility: false,
        type: '',
        data: {},
        filters: {}
      }
    }
  },
  watch: {
    selectedCompany () {
      this.closeGlobalDrawer()
    },

    activeTab (val) {
      this.reportItems = 0
      this.closeGlobalDrawer()
      this.setRouteType(val)
      this.selectedPeriod = 'currentMonth'
    },

    filters: {
      deep: true,
      handler () {
        this.closeGlobalDrawer()
      }
    }
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    getRouteType () {
      const ROLE_GET_REPORT_TAXIJOBS = this.claims.report['ROLE_GET_REPORT_TAXIJOBS']
      const ROLE_GET_REPORT_COSTCENTER = this.claims.report['ROLE_GET_REPORT_COSTCENTER']
      const ROLE_GET_REPORT_EMPLOYEE = this.claims.report['ROLE_GET_REPORT_EMPLOYEE']

      if (this.routeReportType === 'corridas' && ROLE_GET_REPORT_TAXIJOBS) {
        this.activeTab = 0
        return
      }

      if (this.routeReportType === 'centro-de-custo' && ROLE_GET_REPORT_COSTCENTER) {
        this.activeTab = 1
        return
      }

      if (this.routeReportType === 'colaborador' && ROLE_GET_REPORT_EMPLOYEE) {
        this.activeTab = 2
        return
      }

      if (!ROLE_GET_REPORT_TAXIJOBS && ROLE_GET_REPORT_COSTCENTER) {
        this.activeTab = 1
        return
      }

      if (!ROLE_GET_REPORT_TAXIJOBS && !ROLE_GET_REPORT_COSTCENTER && ROLE_GET_REPORT_EMPLOYEE) {
        this.activeTab = 2
      }

      this.setRouteType()
    },

    setRouteType () {
      const path = location.hash.split('/')[1]

      if (this.activeTab === 0) {
        history.pushState({}, null, `/#/${path}/corridas`)
        return
      }

      if (this.activeTab === 1) {
        history.pushState({}, null, `/#/${path}/centro-de-custo`)
        return
      }

      if (this.activeTab === 2) {
        history.pushState({}, null, `/#/${path}/colaborador`)
      }
    },

    updateFilters ({ type, filters }) {
      this.filters[type] = filters
    },

    getFilters (type) {
      return this.isValidObject(this.filters) &&
        this.isValidObject(this.filters[type]) &&
        this.filters[type].startDate &&
        this.filters[type].endDate
        ? { ...this.filters[type] } : {}
    },

    openGlobalDrawer ({ visibility = false, type = '', data = {}, filters = {} }) {
      this.globalDrawer = {
        visibility,
        type,
        data,
        filters
      }
    },

    closeGlobalDrawer () {
      this.clearSelectedItem = !this.clearSelectedItem

      this.globalDrawer = {
        visibility: false,
        type: '',
        data: {},
        filters: {}
      }
    },

    openRideDrawer (ride) {
      this.openGlobalDrawer({
        visibility: true,
        type: 'ride',
        data: { id: ride.taxiJobId },
        filters: { ...this.getFilters('rides') }
      })
    },

    openCostCenterDrawer (costCenter) {
      this.openGlobalDrawer({
        visibility: true,
        type: 'costCenter',
        data: {
          id: costCenter.id,
          name: costCenter.id
        },
        filters: {
          ...this.getFilters('costCenter'),
          costCenterId: costCenter.id
        }
      })
    },

    openEmployeeDrawer (employee) {
      this.openGlobalDrawer({
        visibility: true,
        type: 'employee',
        data: {
          id: employee.employeeId,
          name: employee.employeeName
        },
        filters: {
          ...this.getFilters('employee'),
          employeeId: employee.employeeId
        }
      })
    },

    changePeriod (period) {
      this.selectedPeriod = period
    },

    setReportItems (itemCount) {
      setTimeout(() => {
        this.reportItems = itemCount
      }, 150)
    },

    goToConsolidatedReportsPage () {
      this.$router.push({ name: 'ConsolidatedReports' })
    },

    goToNewConsolidatedReport () {
      this.$router.push({ name: 'ConsolidatedReport' })
    }
  },
  mounted () {
    this.getRouteType()
  }
}
</script>

<style lang="scss">
.v-tabs-reports__hidden {

  .v-tabs__bar {
    display: none !important;
  }
}
</style>
